module.exports = __webpack_public_path__ + "img/img12.d7fea830.png";